import { render } from "./RowDetail.vue?vue&type=template&id=715e7d4d&scoped=true"
import script from "./RowDetail.vue?vue&type=script&lang=js"
export * from "./RowDetail.vue?vue&type=script&lang=js"

import "./RowDetail.vue?vue&type=style&index=0&id=715e7d4d&scoped=true&lang=less"
import "./RowDetail.vue?vue&type=style&index=1&id=715e7d4d&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715e7d4d"]])

export default __exports__